import { AxiosResponse } from "axios";

import { httpClient } from "@/shared/services/http";
import { AssessmentInsightsData } from "@/modules/assessments/types/insights.interface";

export class AssessmentInsightsHttpService {
  static async getAssessmentInsights(
    assessmentId: number,
    startDate?: string,
    endDate?: string,
  ): Promise<AssessmentInsightsData> {
    const { data } = await httpClient.get<AssessmentInsightsData>(`/api/assessments/${assessmentId}/insights`, {
      params: { startDate, endDate },
    });
    return data;
  }

  static async exportAssessmentInsights({
    assessmentId,
    startDate,
    endDate,
  }: {
    assessmentId: number;
    startDate?: string;
    endDate?: string;
  }): Promise<AxiosResponse<Blob>> {
    return httpClient.get(`/api/assessments/${assessmentId}/insights/export`, {
      params: { startDate, endDate },
      responseType: "blob",
    });
  }
}
